import apiInstance from './apiService';

// Expected payload: { subject, body, channel, priority, custom_fields }
export const submitSupportTicket = (payload) => apiInstance.post('/api/v2/support-tickets', payload);

export const uploadSupportTicketAttachments = (messageId, files) => {
  const formData = new FormData();
  files.forEach((file) => formData.append('files', file));
  return apiInstance.post(`/api/v2/support-tickets/messages/${messageId}/attachments`, formData);
};

export default submitSupportTicket;
